import { ReactNode } from 'react';

import { Tooltip } from '../../../../../Tooltip';
import { Box } from '../../../../../Box';

import { useStyles } from './ToolbarButton.styles';

interface ToolbarButtonProps {
  tooltip: string;
  onClick: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  children: ReactNode;
}

export const ToolbarButton = ({
  tooltip,
  onClick,
  children,
}: ToolbarButtonProps) => {
  const { classes } = useStyles();

  const handleClick = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    onClick(event);
  };

  return (
    <Tooltip title={tooltip} placement="bottom">
      <Box className={classes.root} onClick={handleClick}>
        {children}
      </Box>
    </Tooltip>
  );
};
